var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActioncentreAlt = function SvgActioncentreAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M7 5a2 2 0 0 0-2 2v30a2 2 0 0 0 2 2h56a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm3.5 7a1.5 1.5 0 0 1 1.5-1.5h30a1.5 1.5 0 0 1 0 3H12a1.5 1.5 0 0 1-1.5-1.5m0 6a1.5 1.5 0 0 1 1.5-1.5h35a1.5 1.5 0 0 1 0 3H12a1.5 1.5 0 0 1-1.5-1.5m1.5 4.5a1.5 1.5 0 0 0 0 3h28a1.5 1.5 0 0 0 0-3zm48.083 1.297a1.5 1.5 0 0 1 0 2.122l-7.164 7.164a1.5 1.5 0 0 1-2.122 0l-3.858-3.858a1.5 1.5 0 1 1 2.122-2.121l2.797 2.797 6.104-6.104a1.5 1.5 0 0 1 2.121 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2F68D1",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M56 39v8h-6M20 60h-9v-8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M50 44v1.5h-3a1.5 1.5 0 0 0 0 3h3V50a2 2 0 0 1-2 2H12.5v-3a1.5 1.5 0 0 0-3 0v3H7a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h41a2 2 0 0 1 2 2",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    fillRule: "evenodd",
    d: "M23 61.5a1.5 1.5 0 0 0 0-3h-3V57a2 2 0 0 1 2-2h41a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H22a2 2 0 0 1-2-2v-1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgActioncentreAlt;